import { render, staticRenderFns } from "./generate-floating-ip.vue?vue&type=template&id=708aea73&scoped=true&"
import script from "./generate-floating-ip.vue?vue&type=script&lang=js&"
export * from "./generate-floating-ip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708aea73",
  null
  
)

export default component.exports